module.exports = __webpack_public_path__ + "media/images/icon-comment@3x-3f8bb615b3234b445eb67a6b426b2a24.png";